import {newProjectUrl} from '../../helpers/externalRoutes';
import {mapState} from 'vuex';
import {
    CLAIM_YOUR_HOME_MODAL_OPEN
} from "../Modals/ClaimYourHomeModal/ClaimYourHomeModal.vue";
import AddressAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/AddressAppResource';

export default {
    props: {
        projectType: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState({
            authUser: state => state.landingPage.authUser
        }),
        hasAddressError() {
            return this.errors.hasOwnProperty('address');
        },
        canAddressPass() {
            return !!this.address?.city &&
                !!this.address?.state &&
                !!this.address?.street &&
                this.isZipCodeValid;
        },
        primaryColorStyle() {
            return { '--landing-page-primary-color': this.landingPage.primaryColor };
        },
    },
    methods: {
        addressIsNotCompleted(address) {
            return !address.zip || !address.city || !address.state || !address.street
        },
        validateAddressRequiredFields() {
            if (!this.canAddressPass) {
                const addressErrors = [];

                if (!this.address?.street) {
                    addressErrors.push('Address Street is required');
                }

                if (!this.address?.city) {
                    addressErrors.push('Address City & State is required');
                }

                if (!this.isZipCodeValid) {
                    addressErrors.push('Address Valid Zip Code is required');
                }

                if (addressErrors.length > 0) {
                    this.$set(this.errors, 'address', addressErrors);
                    return true;
                }
            }

            return false;
        },
        onCustomAddressClaimMyHome() {
            if (!this.validateAddressRequiredFields()) {
                this.errors = {};
                this.handleClaimMyHomeClick();
            }
        },
        handleClaimMyHomeClick() {
            if (this.addressIsNotCompleted(this.address)) {
                console.warn('handleClaimMyHomeClick Address is not valid: ', this.address);
                return;
            }

            if (!this.projectType) {
                return;
            }

            if (this.authUser.uuid) {
                if (this.landingPage.userUuid === this.authUser.uuid) {
                    this.showNotification({
                        message: 'You can not create a hub from your own Landing Page! Please log in as another user!',
                        type: 'error',
                    });
                    return;
                }
                window.location = newProjectUrl({
                    type: this.HOHProjectTypeUuid,

                    hohAddress: btoa(JSON.stringify(this.address.attributes)),
                    landingPageUuid: window.landingPageUuid,
                });
                return;
            }

            this.$bus.$emit(CLAIM_YOUR_HOME_MODAL_OPEN, {
                address: this.address,
                propImgSrc: this.propImgSrc,
                HOHProjectTypeUuid: this.projectType,
                hohEmail: localStorage.getItem('hohEmail') ? localStorage.getItem('hohEmail') : '',
                landingPage: this.landingPage,
            });
        },
        handleAddressInput(address) {
            if (!address) {
                console.warn('Address is not valid: ', address);
            }

            this.address = address;
        },
        onCustomAddressSelected(event) {
            this.isCustomAddressSelected = event;
            this.errors = {};
            if (this.isCustomAddressSelected) {
                window.scrollBy({ top: 200, behavior: 'smooth' });
            }
        },
        resetAddress() {
            this.address = null;
            this.errors = {};
        },
    },
};
